import React from "react";
import "./ServiceDetailPage.css";
import { useScrollToTopOnMount } from "../hooks/useScrollToTop";

function ServiceDetailPage({
  pageClassName,
  heroClassName,
  title,
  subtitle,
  heroPrimaryLabel,
  heroSecondaryLabel,
  overviewLead,
  overviewBullets,
  features,
  solutionsHeading,
  solutions,
  pricingLead,
  pricingTiers,
  contactTitle,
  contactLead,
}) {
  useScrollToTopOnMount();

  return (
    <main className={pageClassName}>
      <header className={heroClassName}>
        <div className="container">
          <h1>{title}</h1>
          <p className="subtitle">{subtitle}</p>
          <div className="hero-actions">
            <a href="#overview" className="btn btn-primary">{heroPrimaryLabel}</a>
            <a href="#contact" className="btn btn-secondary">{heroSecondaryLabel}</a>
          </div>
        </div>
      </header>

      <section id="overview" className="section">
        <div className="container">
          <h2>Overview</h2>
          <p className="lead">{overviewLead}</p>
          <ul className="bullets">
            {overviewBullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </div>
      </section>

      <section id="features" className="section section-alt">
        <div className="container">
          <h2>Key Features</h2>
          <div className="grid">
            {features.map((feature) => (
              <div key={feature.title} className="card">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="solutions" className="section">
        <div className="container">
          <h2>{solutionsHeading}</h2>
          <div className="grid grid-2">
            {solutions.map((solution) => (
              <div key={solution.title} className="card">
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
                <ul className="mini-list">
                  {solution.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="pricing" className="section section-alt">
        <div className="container">
          <h2>Pricing</h2>
          <p className="lead">{pricingLead}</p>
          <div className="pricing">
            {pricingTiers.map((tier) => (
              <div
                key={tier.title}
                className={`tier${tier.featured ? " tier-featured" : ""}`}
              >
                <h3>{tier.title}</h3>
                <p>{tier.description}</p>
                <ul>
                  {tier.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <a href="#contact" className="btn btn-primary">Get Quote</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="section cta">
        <div className="container">
          <h2>{contactTitle}</h2>
          <p className="lead">{contactLead}</p>
          <a href="/contact" className="btn btn-primary">Contact Us</a>
        </div>
      </section>
    </main>
  );
}

export default ServiceDetailPage;